import { SummaryTypeUi } from './summary-type-ui.model';
import { maturitySummaryUi } from './maturity.summary-ui';
import { temperatureSummaryUi } from './temperature.summary-ui';

export * from './summary-type-ui.model';

/** Keyed by Measurement.measurementType. Absent key ⇒ "not supported yet" notice. */
export const SUMMARY_TYPE_REGISTRY: Record<string, SummaryTypeUi> = {
  MaturityMeasurement: maturitySummaryUi,
  TemperatureMeasurement: temperatureSummaryUi,
};
